module.exports={
  noResult:            'Airline nicht gefunden'
}
